import { createContext } from 'react';
export var AuthContext = createContext(null);
export var KlsContext = createContext(null);
export var SetAuthItemContext = createContext(null);
export var MultiSetAuthItemContext = createContext(null);
export var GetAuthItemContext = createContext(null);
export var RemoveAuthItemContext = createContext(null);
export var GetAccessTokenContext = createContext(null);
export var IsAuthenticatedContext = createContext(null);
export var HasTwoFactorTokenContext = createContext(null);
export var LogoutContext = createContext(null);
export var AuthFetchContext = createContext(null);
export var SuperAuthFetchContext = createContext(null);
export var LoginContext = createContext(null);
export var SendCodeContext = createContext(null);
export var LoginWithCodeContext = createContext(null);
export var InterceptorsContext = createContext(null);
export var AccessTokenCookieContext = createContext(null);
//# sourceMappingURL=auth-context.js.map